$('.reviews-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  speed: 300,
  touchThreshold: 100,
  lazyLoad: 'ondemand',
  prevArrow: $('.reviews-arrow'),
  nextArrow: $('.reviews-arrow'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});